import { Suspense, lazy } from 'react';

import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import UploadPDF from '@/components/UploadPDF';
import { useUploadPdf } from '@/components/UploadPDF/hooks';
import { useShallowEqualSelector } from '@/hooks';
import routes from '@/routes';

import { DailyLimitModalListener } from '../MyDocuments/DailyLimitModal';
import HowTo from './HowTo/HowTo';
import Tools from './Tools/Tools';
import WhyPDFe from './WhyPDFe/WhyPDFe';

const FaqSection = lazy(() => import('./Faqs'));

function Home() {
	const { t } = useTranslation();
	const { loggedIn, authModalOpen } = useShallowEqualSelector(
		({ profile }) => ({
			loggedIn: profile.loggedIn,
			authModalOpen: profile.authModalOpen
		})
	);
	const { handleDrop, loading } = useUploadPdf();

	if (loggedIn && !authModalOpen) {
		return <Navigate to={routes.myDocuments} />;
	}

	return (
		<>
			<div className="bg-grey-100">
				<div className="relative flex flex-col">
					<div className="absolute inset-0 z-0 overflow-hidden">
						<div className="absolute left-0 right-0 top-[30rem] z-0 mx-auto h-[294px] w-[294px] rounded-full bg-red blur-[150px]" />
						<div className="absolute -bottom-96 right-0 z-0 hidden h-[468px] w-[468px] rounded-full bg-red blur-[150px] lg:block" />
					</div>
					<main className="container z-10 flex flex-col items-center pt-[28px] text-center lg:pt-[72px]">
						<h1 className="mb-3 font-title text-[32px] font-semibold leading-10 lg:text-[56px] lg:font-bold lg:leading-[64px]">
							{t('home.title')}
						</h1>
						<h2 className="lg-text-base mb-[28px] text-sm lg:mb-8">
							{t('home.subtitle')}
						</h2>
						<UploadPDF onDrop={handleDrop} loading={loading} />
					</main>
					<section className="relative z-10 mt-[133px] flex justify-center lg:mt-[145px]">
						<Tools />
					</section>
					<HowTo />
				</div>
			</div>

			<section className="container flex justify-start py-20 lg:py-32">
				<WhyPDFe />
			</section>

			<section
				className="flex justify-center bg-grey-100 py-20 lg:pb-[192px] lg:pt-[100px]"
				id="faqs"
			>
				<Suspense>
					<FaqSection isHome />
				</Suspense>
			</section>

			<DailyLimitModalListener />
		</>
	);
}

export default Home;
